var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top-banner-title-comp"},[_c('div',{staticClass:"return",on:{"click":_vm.goToPreviousView}},[_c('i',{staticClass:"mdi mdi-arrow-left"})]),_c('div',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.title)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }